import React, { useEffect } from 'react';
//import { servicios } from '../../json/organismos';
import './organismos.css';

const Servicios = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Trámites y servicios</h3>
                <hr className='hr-gob'/>
            </div>
            <div className='organismos'>
                {
                    window._my_servicios.filter(p => p.cad===0).map((item, index)=>(
                        <a href={item.url} target="_new" key={ index }>
                            <h5 className='title'>{item.nombre}</h5>
                            <p>{item.descripcion}</p>
                        </a>
                    ))
                }
            </div>
            <div id="mi_espacio"/>
        </div>
    </div>
  )
}

export default Servicios